let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b006v")).then(() => parcelRequire('hcMLU'));